<template>
  <div class="containerBox">
    <div class="stepsContainer">
      <div class="stepsItem">
        <van-image width="36" height="36" :src="icon1" />
        <div class="stepsText">司机接单</div>
      </div>
      <div>
        <van-image width="35" height="8" :src="imgUrl" class="arrow" />
      </div>
      <div class="stepsItem">
        <van-image width="36" height="36" :src="icon2" />
        <div class="stepsText">预支付</div>
      </div>
      <div>
        <van-image width="35" height="8" :src="imgUrl" class="arrow" />
      </div>
      <div class="stepsItem">
        <van-image width="36" height="36" :src="icon3" v-if='imgData>1'/>
        <van-image width="36" height="36" :src="icon31" v-else />
        <div class="stepsText">开始行程</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    imgData:{
      type:Number,
    }
  },
  data() {
    return {
      imgUrl: require("../../assets/components/arrow.png"),
      icon1: require("../../assets/icon/icon-1.png"),
      icon2: require("../../assets/icon/icon-2.png"),
      icon3: require("../../assets/icon/icon-3.png"),
      icon31: require("../../assets/icon/icon-3-1.png")
    };
  }
};
</script>
<style lang="scss" scoped>
$gray6: #666666;

.containerBox {
  text-align: center;
}

.stepsContainer {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  font-size:35px;
  color: $gray6;
  .arrow {
    margin-top: 36px;
  }
  .stepsItem {
    width:140px;
    .stepsText {
      margin-top: 10px;
      font-size: 32px;
    
    }
  }
}
</style>